import { fetchJson2 } from 'helpers/api';

const fetchBusinessLines = (params) => {
  const searchParams = new URLSearchParams(params.filters);
  return fetchJson2(`/api/businessLines?${searchParams}`, params.cancellationToken);
};

export { fetchBusinessLines };
